export default {

  LOAD_COMPANY_LIST (state, data) {
    state.companyListInfo = data
    state.companyList = data.data
  },

  LOAD_COMPANY (state, data) {
    state.companyInfo = data
  },

  LOAD_MEMBER_LIST (state, data) {
    state.memberList = data.data
  }

}
